import { useQuery } from "@tanstack/react-query";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";

export interface ResellerCounts {
  devices: number;
  users: number;
  integrators: number;
  providers: number;
  models: number;
  avisos: number;
}

interface CountsResponse {
  data: Partial<ResellerCounts>;
}

const ONLY = "integrators,providers,models,devices,users,avisos";

export function useResellerCounts() {
  const companyId = useCompaniesStore((s) => s.companyId);
  const roleId = localStorage.getItem("userRoleId") || "";
  return useQuery({
    queryKey: ["resellerCounts", companyId],
    queryFn: ({ signal }) =>
      getJson<CountsResponse>(
        "/dashboardCounts",
        { only: ONLY, roleId },
        { signal },
      ).then((res) => res.data ?? {}),
  });
}
